export default __webpack_public_path__ + "static/media/gesture-pinch.9e1a3665.svg";